Maps =  {

	isMapOpen : false

	init : ->
		console.log 'Maps init'

		@initMap()
		@revealMap()

	initMap : ->
		mapElt = $('.gmap') 

		marker = mapElt.find('.marker')
		
		args = {
			zoom		: 16,
			center		: new google.maps.LatLng($(marker).attr('data-lat'), $(marker).attr('data-lng')),
			mapTypeId	: google.maps.MapTypeId.ROADMAP,
			fullscreenControl: false,
			mapTypeControl: false
		}
		
		map = new google.maps.Map( mapElt[0], args);
		map.markers = [];
			
		latlng = new google.maps.LatLng( $(marker).attr('data-lat'), $(marker).attr('data-lng') );

		marker = new google.maps.Marker({
			position	: latlng,
			icon		: base_url + '/img/ico-pin.svg',
			map			: map
		})

		map.markers.push( marker );

	revealMap : ->

		_this = @

		$('.map-container .map-content').on "mouseenter", (ev) ->
			if not _this.isMapOpen
				TweenLite.to(@, 0.3, {width:'141px', height: '140px', ease:Expo.easeOut})

		$('.map-container .map-content').on "mouseleave", (ev) ->
			if not _this.isMapOpen
				TweenLite.to(@, 0.3, {width:'117px', height: '116px', ease:Expo.easeOut})

		$('.map-container .map-content').on "click", (ev) ->
			mapOverlay = $(@).parents('.map-overlay')
			# Update flag
			_this.isMapOpen = true			
			# Scroll to map top
			mapOffset = mapOverlay.find('.gmap').offset().top
			TweenLite.to(window, 0.3, { scrollTo: {y: mapOffset}, ease:Quint.easeInOut })

			# Disable Scroll
			$('body').css('overflow', 'hidden')

			# Deploy map
			TweenLite.to(@, 0.5, {width:'150vw', height: '150vw', ease:Quad.easeInOut, delay: 0.3})
			# Show close CTA
			TweenLite.to(mapOverlay.find('.cta'), 0.3, {autoAlpha:1, ease:Quad.easeOut, delay:0.3})
			# Enable pointer events on map
			$(@).find('.gmap').css('pointer-events', 'initial')

		$('.map-container .cta_close').on "click", (ev) ->
			mapContent = $(@).parents('.map-overlay').find('.map-content')
			# Update flag
			_this.isMapOpen = false
			# Enable scroll
			$('body').css('overflow', 'visible')
			
			# Hide cta
			TweenLite.to(@, 0.3, {autoAlpha:0, ease:Quad.easeOut})
			# Hide map
			TweenLite.to(mapContent, 0.5, {width:'117px', height: '116px', ease:Quad.easeOut})

			# Disable pointer events on map
			mapContent.find('.gmap').css('pointer-events', 'none')


	destroy : ->
		console.log "Maps destroy"
		
}